export default __webpack_public_path__ + "static/media/etranslator-screenshot-05.4c5f0be7.png";